export function setElementVisibility(id: string, visibility: boolean): void {
    const style = (document.getElementById(id) as HTMLElement)?.style;

    if (style) {
        style.visibility = visibility ? 'visible' : 'hidden';
    }
}
